/***************************************** Slidshow *****************************/

// slideshow
new Swiper("#productSwiper", {
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: '#productSwiperRight',
        prevEl: '#productSwiperLeft',
    },
    pagination: {
        el: '#productSwiperPagination',
        clickable: true
    }
})

// show hide the buy now button
window.addEventListener('scroll', function () {
    if (document.querySelector("#productATC").getBoundingClientRect().top < 0) {
        document.querySelector('#buyNow').classList.add('active');
    } else {
        document.querySelector('#buyNow').classList.remove('active');
    }
});

// listen for buy now click, and scroll to the top of the page smoothly
document.querySelector('#buyNow').addEventListener('click', function (e) {
    e.preventDefault();

    // scroll to top on desktop, otherwise scroll to title
    if (window.innerWidth > 800) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    } else {
        // scroll to the title which is essential the height of the productSwiper
        window.scrollTo({
            top: document.querySelector("#productSwiper").clientHeight - 60,
            behavior: 'smooth'
        });
    }
});

/***************************************** Subscribe /Buy Once *****************************/

// subscribe or buy once change event
document.querySelectorAll(".productFormRadioInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // sync action across all forms
        document.querySelectorAll(`.productFormRadioInput[value="${this.value}"]`).forEach(element => {
            // check this
            element.checked = true;

            // update atc lang
            updateATCButton();

            if (this.value == "Subscribe") {
                // hide frequency selector
                document.querySelectorAll(".productFormFrequency").forEach(element => {
                    element.classList.add("active");
                })
            } else {
                // show frequency selector
                document.querySelectorAll(".productFormFrequency").forEach(element => {
                    element.classList.remove("active");
                })
            }
        })
    });
})

/***************************************** Rolls *****************************/

// rolls change event
document.querySelectorAll(".productFormRollsItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // change active product form
        this.closest(".productForm").classList.remove("active");
        document.querySelector(`.productForm[variant="${this.getAttribute("variant")}"]`).classList.add("active");
        updateATCButton();
    });
})

/***************************************** Frequency *****************************/

// frequency open
document.querySelectorAll(".productFormFrequencySelectLabel").forEach(function (element) {
    element.addEventListener("click", function () {
        this.classList.add("active");
    })
});

// frequency close
document.querySelector("body").addEventListener("click", function (e) {
    let activeSelect = document.querySelector(".productFormFrequencySelectLabel.active");
    if (activeSelect && !e.target.closest(".productFormFrequencySelectLabel.active")) {
        activeSelect.classList.remove("active");
    }
});

// frequency change
document.querySelectorAll(".productFormFrequencySelectOption").forEach(function (element) {
    element.addEventListener("click", function () {
        this.closest(".productFormFrequency").setAttribute("selling_plan", this.getAttribute("selling_plan"))
        this.parentElement.parentElement.querySelector(".productFormFrequencySelectLabel").innerHTML = this.innerHTML;
    });
})

// frequency setup
// popular is the default
document.querySelectorAll(".productFormFrequencySelectOption span.popular").forEach(function (element) {
    element.click();
})


/**************************************** ATC *************************************/

function updateATCButton() {
    // change verbiage
    if (document.querySelector(`.productFormRadioInput[value="Subscribe"]:checked`)) {
        document.querySelector("#productATC").textContent = "Subscribe";
    } else {
        document.querySelector("#productATC").textContent = "Add to Cart";
    }
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

document.querySelector("#productATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // collect formdata
    let formData = {
        id: parseInt(document.querySelector(".productForm.active").getAttribute("variant")),
        quantity: 1
    };

    // Subscription
    if (document.querySelector(`.productFormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".productForm.active .productFormFrequency").getAttribute("selling_plan"))
    }

    this.classList.add("loading");

    // clear cart
    await fetch("/cart/clear.js");

    await addProduct(formData);

    this.classList.remove("loading");

    // check for skip upsell
    if (window.location.href.includes("skip_upsell")) {
        window.location.href = "/cart";
        return;
    }

    // show upsell
    openUpsell();

});

/*********************************** Stars *************/

document.querySelector("#productStars").addEventListener("click", function () {
    document.querySelector("#yotpo").scrollIntoView({
        behavior: "smooth"
    })
});

/*************************************************************************** Upsell *****************************/

// open upsell
function openUpsell() {
    document.querySelector("#productContent").classList.add("upsell");
    if (window.innerWidth <= 800) {
        document.querySelector("body").classList.add("noScroll");
        document.querySelector("#upsell").showModal();
    } else {
        document.querySelector("#upsell").classList.add("active");
    }
}

// close upsell
function closeUpsell() {
    document.querySelector("#productContent").classList.remove("upsell");
    if (window.innerWidth <= 800) {
        document.querySelector("body").classList.remove("noScroll");
        document.querySelector("#upsell").close();
    } else {
        document.querySelector("#upsell").classList.remove("active");
    }
}

// close from back arrow
document.querySelector("#upsellBack").addEventListener("click", function (e) {
    closeUpsell();
})

// close from exit button
document.querySelector("#upsellExit").addEventListener("click", function (e) {
    closeUpsell();
    window.location.href = "/cart";
})

// stars
document.querySelector("#upsellGridBodyStars").addEventListener("click", function () {
    document.querySelector("#yotpo").scrollIntoView({
        behavior: "smooth"
    })
});

// changes rolls
document.querySelector("#upsellRollsSelect").addEventListener("change", function () {
    // hide active form
    document.querySelector(".upsellForm.active").classList.remove("active");

    // show new form
    document.querySelector(`.upsellForm[variant="${this.value}"]`).classList.add("active");
});

/**************** Subscribe / Buy Once ****/

// subscribe or buy once change event
document.querySelectorAll(".upsellFormRadioInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // sync action across all forms
        document.querySelectorAll(`.upsellFormRadioInput[value="${this.value}"]`).forEach(element => {
            // check this
            element.checked = true;

            if (this.value == "Subscribe") {
                // hide frequency selector
                document.querySelectorAll(".upsellFormFrequency").forEach(element => {
                    element.classList.add("active");
                })
            } else {
                // show frequency selector
                document.querySelectorAll(".upsellFormFrequency").forEach(element => {
                    element.classList.remove("active");
                })
            }
        })
    });
})

/******************* Frequency *******/

// frequency open
document.querySelectorAll(".upsellFormFrequencySelectLabel").forEach(function (element) {
    element.addEventListener("click", function () {
        this.classList.add("active");
    })
});

// frequency close
document.querySelector("body").addEventListener("click", function (e) {
    let activeSelect = document.querySelector(".upsellFormFrequencySelectLabel.active");
    if (activeSelect && !e.target.closest(".upsellFormFrequencySelectLabel.active")) {
        activeSelect.classList.remove("active");
    }
});

// frequency change
document.querySelectorAll(".upsellFormFrequencySelectOption").forEach(function (element) {
    element.addEventListener("click", function () {
        this.closest(".upsellFormFrequency").setAttribute("selling_plan", this.getAttribute("selling_plan"))
        this.parentElement.parentElement.querySelector(".upsellFormFrequencySelectLabel").innerHTML = this.innerHTML;
    });
})

// frequency setup
// popular is the default
document.querySelectorAll(".upsellFormFrequencySelectOption span.popular").forEach(function (element) {
    element.click();
})


// add to cart event
document.querySelector("#upsellATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // collect formdata
    let formData = {
        id: parseInt(document.querySelector(".upsellForm.active").getAttribute("variant")),
        quantity: 1
    };

    // Subscription
    if (document.querySelector(`.upsellFormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".upsellForm.active .upsellFormFrequency").getAttribute("selling_plan"))
    }

    this.classList.add("loading");

    await addProduct(formData);

    this.classList.remove("loading");

    window.location.href = "/cart";

});

// track klaviyo
try {
    klaviyo.push(["track", "Viewed Product"]);
} catch (error) {
    console.error("Klaviyo tracking not found");
}

/***************************************** Notify Me *****************************/

document.querySelector("#productNotifyForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    // submit to klaviyo
    sendKlaviyoBackInStockRequest(document.querySelector("#productNotifyFormEmail").value, 47062264119578);

    // reset form
    this.reset();

    // show success message
    document.querySelector("#productNotifyForm").classList.remove("active");
    document.querySelector("#productNotifySuccess").classList.add("active");
});